/* eslint-disable no-prototype-builtins */
import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { toast } from 'react-toastify';
import BackLink from '../../common/back-link/index';
import Divider from '../../common/divider';
import { getAdminOutlet, updateOutletGroups } from '../../../actions/outlet';
import PageTitle from '../../common/page-title';
import OutletRewardDetails from './outlet-reward-details';
import StaffMemberList from '../../common/outlet/staff-member-list';
import OutletGroupDetails from '../../common/outlet/group-details';
import ToastMessage from '../../common/toast-message';
import { getVoucherTypesSetting } from '../../../actions/voucher';
import { getAllGroups } from '../../../actions/groups';
import OutletDetails from '../../common/outlet/outlet-details';
import { destandard } from '../../../utils/commonFunctions';
import { history } from '../../../store';
import OutletDetailField from '../../common/outlet/outlet-detail-field';
import InvalidateScansForm from './invalidate-scans-form';

class OutletView extends Component {
  filterDeliveryFields = (attributes) => {
    const deliveryFields = [
      'delivery-address-1',
      'delivery-address-2',
      'delivery-address-3',
      'use-delivery-address',
      'delivery-eircode',
      'delivery-county',
      'delivery-town'
    ];

    // eslint-disable-next-line prefer-const
    let delivery = {};

    deliveryFields.forEach((d) => {
      if (attributes.hasOwnProperty(d)) {
        delivery[d] = attributes[d];
      }
    });

    return destandard(delivery);
  };

  handleStaffRowClick = (cell, row) => {
    history.push(`/admin/users/${row.id}/details`);
  };

  handleGroupRowClick = (cell, row) => {
    history.push(`/admin/groups/${row.id}/edit`);
  }

  addToGroupButtonClick = () => {
    const { dispatch, formData, outletsGroups } = this.props;

    const outletGroupsIds = outletsGroups.map(outletGroup => (
      `${outletGroup.id}`
    ));

    const newGroupIds = formData.groups.map(groupData => (
      groupData.value
    ));

    const groupIds = newGroupIds.concat(outletGroupsIds);

    const outletData = { outlet_groups: { group_ids: groupIds.flat() } };
    dispatch(updateOutletGroups(this.props.match.params.id, outletData, dispatch));
  }

  removeGroupButtonClick = (groupToRemove) => {
    const { dispatch, outletsGroups } = this.props;

    const groupIds = outletsGroups.filter(group => (
      group.id !== groupToRemove.id
    )).map(groupData => (
      groupData.id
    ));

    const outletData = { outlet_groups: { group_ids: groupIds } };
    dispatch(updateOutletGroups(this.props.match.params.id, outletData, dispatch));
  }

  componentWillMount() {
    const {dispatch} = this.props;
    dispatch(getAdminOutlet(this.props.match.params.id));
    dispatch(getAllGroups());
  }

  componentDidMount() {
    this.props.dispatch(getVoucherTypesSetting());
  }

  notFoundErrorRender() {
    const {errors} = this.props;
    if (typeof errors === 'string' && errors === 'Not Found') {
      toast.error(<ToastMessage iconStyle="error" message={`Outlet not found by id ${this.props.match.params.id}`}/>);

      return true;
    }
    return false;
  }

  render() {
    let rewards = {};
    // eslint-disable-next-line prefer-const
    let nominations = [];
    const {id} = this.props.match.params;
    const {
      loading, voucherFetched, outlet, voucher, outletsGroups, allGroups, formData
    } = this.props;
    const {attributes: details} = outlet;

    if (this.notFoundErrorRender()) {
      return <Redirect to="/admin/outlets"/>;
    }

    if (loading || !voucherFetched) {
      return (
        <p>
          Loading...
        </p>
      );
    }

    const delivery = this.filterDeliveryFields(details);

    if (details['reward-store']) {
      rewards = details['rewards-details'];

      voucher.voucher_types.forEach((v) => {
        nominations[v.id] = v.attributes['voucher-denominations'];
      });
    }

    return (
      <div className="fluid">
        <div className="container-fluid">
          <Row>
            <Col md={12}>

              <BackLink href="/admin/outlets"/>

              <PageTitle>
                VIEW OUTLET
              </PageTitle>

              <Row>
                <Col md={12}>
                  <h3>
                    Outlet details
                  </h3>
                  <OutletDetails details={outlet.attributes} id={outlet.id}/>
                </Col>
              </Row>
              <Divider/>
              {
                outlet.attributes['scan-invalidation-status'] === 'in_progress' ? (
                  <div>
                    <h3>
                      Invalidating scans in progress
                      <span
                        className="glyphicon glyphicon-refresh"
                        aria-hidden="true"
                        style={{marginRight: '0.5em', marginLeft: '10px'}}
                      />
                    </h3>
                  </div>
                ) : (
                  <div>
                    <h3>Invalidate scans</h3>
                    <InvalidateScansForm
                      id={id}
                      staffMembers={outlet.relationships['staff-members'].data.map(item => ({
                        id: item.id,
                        name: item.name
                      }))}
                    />
                  </div>
                )
              }

              <Divider/>
              {
                details && details['reward-store'] && (
                  <div>
                    <h3>Rewards Details</h3>
                    <Row className="mg-bottom-20">
                      <Col lg={6}>
                        <OutletDetailField data={details.level} label="Outlet level" or="N/a"/>
                      </Col>
                    </Row>

                    <OutletRewardDetails
                      delivery={delivery}
                      id={id}
                      nominations={nominations}
                      reward={rewards}
                      voucher={voucher}
                    />
                    <Divider/>
                  </div>
                )}
              <div>
                <h3>
                  Staff Details
                </h3>
                <StaffMemberList
                  owner={details.owner}
                  staffMembers={outlet.relationships['staff-members'].data}
                  rowClick={this.handleStaffRowClick}
                />
              </div>
              <Divider/>
              <div>
                <h3>
                  Group Details
                </h3>
                <OutletGroupDetails
                  outletsGroups={outletsGroups}
                  formData={formData.groups}
                  allGroups={allGroups}
                  rowClick={this.handleGroupRowClick}
                  addToGroupButtonClick={this.addToGroupButtonClick}
                  removeGroupButtonClick={this.removeGroupButtonClick}
                />
              </div>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    voucher: state.voucher,
    voucherFetched: state.voucher.fetched,
    outlet: state.store.outlet,
    outletsGroups: state.store.relationships.groups,
    allGroups: state.groups.groups,
    loading: state.store.fetching && !state.store.fetched,
    errors: state.store.errors,
    formData: state.deep.admin_outlet_view
  };
}

export default connect(mapStateToProps)(OutletView);



// WEBPACK FOOTER //
// ./src/components/admin/outlet-view/index.jsx